/* eslint-disable */

import { toCurrency } from '../../utils/CurrencyUtil'
import MFNavbar from '../../Components/MutualFunds/MFNavbar'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import { Button } from '../../Components/ui/button'
import { MobileSearchInput } from '../../Components/ui/mobile-search-input'
import env from '../../env/env'
import { isDematUser } from '../../utils/AuthUtil'
import { useEffect, useState } from 'react'
import useDebounce from '../../hooks/useDebounce'
import { MFRecentlyViewed } from '../../store/MFStore'
import { useRecoilValueLoadable } from 'recoil'
import { get } from '../../http/restservice'
import { useNavigate } from 'react-router-dom'
import { Bug } from 'lucide-react'
import { DEBUG_FUND, isDebugSearchQuery } from '../../constants/debugFund'
import { AnimatePresence } from 'framer-motion'
import {
  AnimatedSearchItem,
  AnimatedSearchList,
  AnimatedSearchStatus,
} from '../../Components/ui/animated-search-results'

const MFTopNavbar = () => {
  const navigate = useNavigate()
  const [searchData, setSearchData] = useState([])
  const [query, setQuery] = useState('')
  const [searchLoading, setSearchLoading] = useState(false)
  const debouncedSearchTerm = useDebounce(query, 500)
  const [isOpen, setIsOpen] = useState(false)

  const handleSearchOpen = () => {
    setIsOpen(!isOpen)
  }

  const handleSearchCancel = () => {
    setIsOpen(false)
    setQuery('')
  }

  useEffect(() => {
    const searchFunds = async () => {
      if (isDebugSearchQuery(debouncedSearchTerm)) {
        setSearchLoading(false)
        setSearchData([DEBUG_FUND])
        return
      }

      setSearchLoading(true)
      const response = await get(
        `/mutualfundservice/api/mfData/allFunds?search=${debouncedSearchTerm}`,
      )
      setSearchLoading(false)

      if (response.isError) {
        setSearchData([])
      }

      if (!response.isError) {
        setSearchData(response?.funds)
      }
    }

    if (debouncedSearchTerm) {
      searchFunds()
    } else {
      setSearchData([])
    }
  }, [debouncedSearchTerm])

  const handleFabStarNavigate = (fund) => {
    setIsOpen(false)

    if (fund?.isDebugFund) {
      navigate('/dashboard/debug-popups')
      return
    }

    navigate(`/dashboard/mutual-funds/details`, {
      state: {
        fundDetails: fund,
        schemeCode: fund.schemeCode,
      },
    })
  }

  return (
    <div className='bg-white dark:bg-[var(--fb-bg)]'>
      <MFNavbar handleSearchOpen={handleSearchOpen} />

      <Dialog
        open={isOpen}
        onOpenChange={handleSearchOpen}
        aria-labelledby='dialog-title'
        aria-describedby='dialog-description'
      >
        <DialogContent
          mobileFullscreen
          className='font-DMSans duration-300 ease-out justify-start hide-scrollbar'
        >
          <DialogHeader>
            <DialogTitle>
              <div className='flex items-center mb-4'>
                <MobileSearchInput
                  placeholder='Search for funds'
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  handleSearchCancel={handleSearchCancel}
                />
              </div>
            </DialogTitle>
          </DialogHeader>

          {!debouncedSearchTerm && isDematUser() && (
            <div className='flex flex-col'>
              <div className='flex gap-x-2 items-center'>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/orders')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  Orders
                </Button>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/sips')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  SIPs
                </Button>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/investments')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  Investments
                </Button>
              </div>
            </div>
          )}

          {/* {!debouncedSearchTerm && recentlyViewed?.state != 'hasValue' && (
            <div className='mt-5'>
              <h2 className='font-semibold text-primary-700 leading-6 tracking-[-4%]'>
                Fabstar funds
              </h2>
              <div>
                {fabStarFunds.state === 'hasValue' &&
                  fabStarFunds?.contents?.data?.map((fund) => (
                    <div
                      className='cursor-pointer flex gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                      key={fund?.amcCode}
                      onClick={() => handleFabStarNavigate(fund)}
                    >
                      <img
                        src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                        className='h-9 w-9 rounded-sm'
                      />

                      <div className='w-full'>
                        <div className='flex justify-between'>
                          <h2 className='font-semibold leading-5 text-sm text-black-500 text-nowrap'>
                            {fund?.legalName
                              ? fund?.legalName?.slice(0, 25)
                              : fund?.sName?.slice(0, 25)}
                            ...
                          </h2>

                          <p
                            className={`font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                          >
                            {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                          </p>
                        </div>
                        <p className='text-xs text-black-400 font-medium leading-4'>
                          Starts at{' '}
                          <span className='text-xs text-black-500 font-semibold'>
                            ₹ {toCurrency(fund?.minInvt)}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {!debouncedSearchTerm && (
            <div className='mt-5'>
              <h2 className='font-semibold text-primary-700 leading-6 tracking-[-4%]'>
                Recently viewed funds
              </h2>
              <div>
                {fabStarFunds.state === 'hasValue' &&
                  fabStarFunds?.contents?.data?.map((fund) => (
                    <div
                      className='cursor-pointer flex gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                      key={fund?.amcCode}
                      onClick={() => handleFabStarNavigate(fund)}
                    >
                      <img
                        src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                        className='h-9 w-9 rounded-sm'
                      />

                      <div className='w-full'>
                        <div className='flex justify-between'>
                          <h2 className='font-semibold leading-5 text-sm text-black-500 text-nowrap'>
                            {fund?.legalName
                              ? fund?.legalName?.slice(0, 25)
                              : fund?.sName?.slice(0, 25)}
                            ...
                          </h2>

                          <p
                            className={`font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                          >
                            {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                          </p>
                        </div>
                        <p className='text-xs text-black-400 font-medium leading-4'>
                          Starts at{' '}
                          <span className='text-xs text-black-500 font-semibold'>
                            ₹ {toCurrency(fund?.minInvt)}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )} */}

          <AnimatePresence mode='wait'>
            {searchLoading ? (
              <AnimatedSearchStatus key='top-mf-search-loading'>Loading...</AnimatedSearchStatus>
            ) : debouncedSearchTerm && searchData.length === 0 ? (
              <AnimatedSearchStatus key='top-mf-search-empty'>
                No funds available
              </AnimatedSearchStatus>
            ) : debouncedSearchTerm ? (
              <AnimatedSearchList key='top-mf-search-results' motionKey={debouncedSearchTerm}>
                {searchData.map((fund) => (
                  <AnimatedSearchItem
                    className='flex min-w-0 gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                    key={fund?.schemeCode || fund?.amcCode}
                    onClick={() => handleFabStarNavigate(fund)}
                  >
                    {fund?.isDebugFund ? (
                      <div className='h-9 w-9 shrink-0 rounded-sm bg-primary-50 text-primary-500 flex items-center justify-center'>
                        <Bug className='h-5 w-5' />
                      </div>
                    ) : (
                      <img
                        src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                        className='h-9 w-9 shrink-0 rounded-sm'
                      />
                    )}

                    <div className='min-w-0 flex-1'>
                      <div className='flex min-w-0 items-start justify-between gap-3'>
                        <h2 className='min-w-0 flex-1 truncate font-semibold leading-5 text-sm text-black-500'>
                          {fund?.isDebugFund
                            ? fund?.legalName
                            : `${
                                fund?.legalName
                                  ? fund?.legalName?.slice(0, 25)
                                  : fund?.sName?.slice(0, 25)
                              }...`}
                        </h2>

                        <p
                          className={`shrink-0 font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                        >
                          {fund?.isDebugFund ? (
                            <span className='text-xs'>Test panel</span>
                          ) : (
                            <>
                              {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                            </>
                          )}
                        </p>
                      </div>
                      <p className='text-xs text-black-400 font-medium leading-4'>
                        {fund?.isDebugFund ? (
                          'Trigger every app popup from one page'
                        ) : (
                          <>
                            Starts at{' '}
                            <span className='text-xs text-black-500 font-semibold'>
                              ₹ {toCurrency(fund?.minInvt)}
                            </span>
                          </>
                        )}
                      </p>
                    </div>
                  </AnimatedSearchItem>
                ))}
              </AnimatedSearchList>
            ) : null}
          </AnimatePresence>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default MFTopNavbar
